import { DateTime } from 'luxon';
import { Address, UserTypeEnum } from '../generated/graphql';
import { UserTypesWithGuestEnum } from '../types/UserTypesWithGuestEnum';

export class UserHelper {
    public static calculateAge(date_of_birth: string) {
        const dob = DateTime.fromISO(date_of_birth);
        const age = DateTime.now().diff(dob, 'years').years;

        return Math.floor(age);
    }

    public static formatFullNameFromAddress(address: Address): string {
        return `${address?.first_name} ${address?.last_name}`.trim();
    }

    public static isShopperOrUser(userType?: string): boolean {
        return (
            userType === UserTypesWithGuestEnum.User
                || userType === UserTypesWithGuestEnum.Shopper
        );
    }

    public static parseUserTypesWithGuest(userType?: string): UserTypesWithGuestEnum {
        if (!userType) {
            return UserTypesWithGuestEnum.Guest;
        }

        const isUserEnumType = Object.values(UserTypeEnum).includes(userType);

        if (!isUserEnumType) {
            return UserTypesWithGuestEnum.Guest;
        }

        return userType as UserTypesWithGuestEnum;
    }
}
